<template>
  <div class="study_details_pdf">
    <!-- Display study type Start-->
    <div class="pdf-item">
      <div class="card br-2">
        <div class="p-10 pb-20">
          <h6 class="fw-bold">GENERIC STUDY SETTINGS</h6>
          <div class="pt-5 row">
            <div class="col-lg-3 col-md-7 p-0">Study type:</div>
            <div class="col-lg-3 col-md-5">
              {{ studyData.subType ? studyData.subType : "Digital Invitation" }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Display study type End-->
    <CountryLanguageDetails class="pdf-item" :countryLanguageDetails="countryList" v-if="studyData.linkedCountryLanguages" />
    <BrandingDetails class="pdf-item" :brandingDetails="studyDetails.studyBrandingDetails" v-if="studyDetails.studyBrandingDetails" :exportPdfClicked="exportPdfClicked" />
    <StudyMilestones class="pdf-item" :studyMilestones="studyDetails.milestonesList" v-if="studyDetails.milestonesList && studyDetails.milestonesList.length > 0" :studyData="studyData" />
    <ParticipantConfiguration
      class="pdf-item"
      :options="{
        isParticipantIdEditable: studyDetails.isParticipantIdEditable,
        isParticipantIdRequired: studyDetails.isParticipantIdRequired,
        participantIdFormatConfigured: studyDetails.participantIdFormatConfigured
      }"
      :allowDuplicatePid="studyDetails.allowDuplicatePid"
    ></ParticipantConfiguration>
    <ParticipantTriggerDayZeroDetail class="pdf-item" v-if="studyDetails.isManualStudyStart"></ParticipantTriggerDayZeroDetail>
    <RegistrationDetails class="pdf-item" :registrationDetails="studyDetails.registrationDetails.participantRegistrationConfigDetails" :studyData="studyData" v-if="studyDetails.registrationDetails" />
    <OnboardingDetails class="pdf-item" :onboardingDetails="studyDetails.welcomeScreenDetails" v-if="studyDetails.welcomeScreenDetails" />
    <EligibilityDetails class="pdf-item" :eligibilityDetails="studyDetails.eligibilityQuestionsDetails" v-if="studyDetails.eligibilityQuestionsDetails && studyDetails.eligibilityQuestionsDetails.length > 0" />
    <eConsentDetails class="pdf-item" :eConsentDetails="studyDetails.eConsentsDetails" :isMultipleConsent="isMultipleConsent" :exportPdfClicked="exportPdfClicked" v-if="!isMultipleConsent && studyDetails.eConsentsDetails" />
    <eConsentDetails class="pdf-item" :eConsentDetails="studyDetails.eConsentsDetails" :isMultipleConsent="isMultipleConsent" :exportPdfClicked="exportPdfClicked" v-if="isMultipleConsent && studyDetails.eConsentsDetails" />
    <SurveyDetails class="pdf-item" :surveyDetails="surveyDetails" :studyData="studyData" v-if="studyDetails.surveysSelected && surveyDetails && !studyData.activityAllowed" />
    <ePRODetails class="pdf-item" :eprosDetails="eprosDetails" :studyData="studyData" v-if="studyDetails.eprosSelected && eprosDetails && !studyData.activityAllowed" />
    <eDRODetails class="pdf-item" :edroDetails="studyDetails.edroDetails" v-if="studyDetails.edroDetails" />
    <ActivitiesDetails class="pdf-item activity-details-item " :activityDetails="activitiesList" :studyData="studyData" :therapeuticAreas="therapeuticAreas" :participantRegistrationConfigDetails="registrationSite && registrationSite.participantRegistrationConfigDetails" v-if="activityDetails && studyData.activityAllowed" :exportPdfClicked="exportPdfClicked" />
    <MobileHealthDataAccess class="pdf-item second-page" :mobileHealthDetails="studyDetails.healthDataAccessDetails" v-if="studyDetails.healthDataAccessDetails && studyDetails.healthDataAccessDetails.length > 0" />
    <DashboardDetails class="pdf-item second-page" :dashboardDetails="studyDetails.dashboardDetails" v-if="studyDetails.dashboardDetails" />
    <NotificationsDetails class="pdf-item second-page" :notificationDetails="studyDetails.customNotificationDetails" v-if="studyDetails.customNotificationDetails && studyDetails.customNotificationDetails.length > 0" />
    <MedicalDevices class="pdf-item second-page" :medicalDeviceDetails="studyDetails.medicalDevicesWearablesDetails" v-if="studyDetails.medicalDevicesWearablesDetails" />
    <EngagementContent class="pdf-item second-page" :engagementContentDetails="studyDetails.learnMoreDetails" v-if="studyDetails.learnMoreDetails" :exportPdfClicked="exportPdfClicked" />
    <TeleHealthDetails class="pdf-item second-page" :visits="visitDetails" :studyDetails="studyDetails" :thRecordingAllowedInCountries="thRecordingAllowedInCountries" :isTelehealthRecordingFeature="isTelehealthRecordingFeature" v-if="studyData.telehealthIntegration && (studyData.ios || studyData.android)" />
    <ParticipantWebDetails class="pdf-item second-page" :agreement="agreement" :eligibility="eligibility" :registrationformWebfields="registrationformWebfields" :registrationSite="registrationSite" :registrationSiteFact="registrationSiteFact" :registrationFormFlag="registrationFormFlag" />
    <div class="pdf-item details second-page" v-if="studyDetails.activityOrderInfos && studyDetails.activityOrderInfos.length > 0">
      <div class="card br-2">
        <div class="p-10">
          <h6 class="fw-bold">ACTIVITY ORDER</h6>
          <div>
            <ul>
              <li v-for="(activity, index) in studyDetails.activityOrderInfos" :key="index">
                {{ activity.activityName }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="pdf-item fs-12 second-page">
      <div class="p-10">
        <p class="mb-0"><b>CONFIDENTIAL</b></p>
        <div>
          This document contains trade secrets or otherwise confidential information owned by THREAD. Access to and use of this information is strictly limited and controlled by THREAD. This document may not be copied, distributed, or otherwise disclosed outside of THREAD’s facilities except under appropriate precautions to maintain the confidentiality hereof, and may not be used in any way not
          expressly authorized by THREAD.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CountryLanguageDetails from "../components/study-details-pdf/country-language-details";
import BrandingDetails from "../components/study-details-pdf/branding-details";
import StudyMilestones from "../components/study-details-pdf/study-milestones";
import RegistrationDetails from "../components/study-details-pdf/registration-details";
import OnboardingDetails from "../components/study-details-pdf/onboarding-details";
import EligibilityDetails from "../components/study-details-pdf/eligibility-details";
import eConsentDetails from "../components/study-details-pdf/econsent-details";
import SurveyDetails from "../components/study-details-pdf/surveys-details";
import ePRODetails from "../components/study-details-pdf/epros-details";
import eDRODetails from "../components/study-details-pdf/edros-details";
import ParticipantTriggerDayZeroDetail from "../components/study-details-pdf/participant-day-zero-details";
import ParticipantConfiguration from "../components/study-details-pdf/participant-configuration";
import ActivitiesDetails from "../components/study-details-pdf/activities-details";
import MobileHealthDataAccess from "../components/study-details-pdf/mobileHealthDataAccess";
import DashboardDetails from "../components/study-details-pdf/dashboards-details";
import NotificationsDetails from "../components/study-details-pdf/notifications-details";
import MedicalDevices from "../components/study-details-pdf/medicaldevices-wearables";
import EngagementContent from "../components/study-details-pdf/engagement-content";
import TeleHealthDetails from "../components/study-details-pdf/teleHealth-details";
import ParticipantWebDetails from "../components/study-details-pdf/participant-web-details";
import ImageToBase64 from "image-to-base64";
import _ from "lodash";
export default {
  name: "study-details-pdf",
  data() {
    return {
      activitiesList: []
    };
  },
  watch: {
    activityDetails(activities) {
      this.activitiesList = _.cloneDeep(activities);
    },
    async exportPdfClicked(value) {
      if (value) {
        await this.convertImageToBase64URLs();
      }
    }
  },
  props: {
    studyData: {
      type: Object
    },
    studyDetails: {
      type: Object
    },
    countryList: {
      type: Array
    },
    isMultipleConsent: {
      type: Boolean
    },
    activityDetails: {
      type: Array
    },
    therapeuticAreas: {
      type: Array
    },
    surveyDetails: {
      type: Array
    },
    eprosDetails: {
      type: Array
    },
    visitDetails: {
      type: Array
    },
    thRecordingAllowedInCountries: {
      type: Array
    },
    isTelehealthRecordingFeature: {
      type: Boolean
    },
    agreement: {
      type: Object
    },
    eligibility: {
      type: Object
    },
    registrationformWebfields: {
      type: Object
    },
    registrationSite: {
      type: Object
    },
    registrationSiteFact: {
      type: Array
    },
    registrationFormFlag: {
      type: Object
    },
    exportPdfClicked: {
      type: Boolean
    }
  },
  methods: {
    async convertImageToBase64URLs() {
      //Lets TRY to convert images in to BASE64
      for (let activityIndex = 0; activityIndex < this.activitiesList.length; activityIndex++) {
        await this.getBase64URLs(this.activitiesList[activityIndex].questions, activityIndex);
      }
    },
    async getBase64URLs(questions, activityIndex) {
      for (let i = 0; i < questions.length; i++) {
        if (questions[i].formattedInformation) {
          this.activitiesList[activityIndex].questions[i].formattedInformation = await this.replaceIframeWithVideoLinks(questions[i].formattedInformation);
          this.activitiesList[activityIndex].questions[i].formattedInformation = await this.replaceImageWithBase64(questions[i].formattedInformation);
        }

        if (questions[i].imageUrl) {
          const base64ImageUrl = await this.getBase64String(questions[i].imageUrl);
          this.$set(this.activitiesList[activityIndex].questions[i], "base64ImageUrl", base64ImageUrl);
        }
        if (questions[i].templateImageUrl) {
          const base64TemplateImageUrl = await this.getBase64String(questions[i].templateImageUrl);
          this.$set(this.activitiesList[activityIndex].questions[i], "base64TemplateImageUrl", base64TemplateImageUrl);
        }
        if (questions[i].type === "Image") {
          for (let j = 0; j < questions[i].languageImageOptions.length; j++) {
            for (let k = 0; k < questions[i].languageImageOptions[j].options.length; k++) {
              const base64Img = await this.getBase64String(questions[i].languageImageOptions[j].options[k].imageUrl);
              this.$set(this.activitiesList[activityIndex].questions[i].languageImageOptions[j].options[k], "base64ImgUrl", base64Img);
            }
          }
        }
      }
    },
    async getBase64String(imageUrl) {
      const base64String = await ImageToBase64(imageUrl) // Image URL
        .then(response => {
          return response;
        });
      return base64String;
    },
    async replaceIframeWithVideoLinks(strOld) {
      let str = strOld;
      const originalString = str;
      const iframes = [];
      const indexes = [...str.matchAll(new RegExp("<iframe", "gi"))].map(a => a.index);
      for (let i = 0; i < indexes.length; i++) {
        iframes[i] = originalString.substring(indexes[i], originalString.indexOf("</iframe", indexes[i]) + 9);
        const videoLink = iframes[i].substring(iframes[i].indexOf("src=") + 5, iframes[i].indexOf('\\"', iframes[i].indexOf("src=") + 5));
        if (videoLink.indexOf("threadresearch") > -1) {
          str = str.replace(iframes[i], "<div><b>There is a link available. Please visit study details page.</b></div>");
        } else {
          str = str.replace(iframes[i], '<div><a href="' + videoLink + '">' + videoLink + "</a></div>");
        }
      }
      return str;
    },
    async replaceImageWithBase64(htmlString) {
      let m;
      const rex = /<img[^>]+src="?([^"\s]+)"?\s*/gi;
      while ((m = rex.exec(htmlString))) {
        const base64Img = await this.getBase64String(m[1]);
        htmlString.replace(m[0], `<img src=\"data:image/png;base64,${base64Img}\"`);
      }
      return htmlString;
    }
  },
  components: {
    CountryLanguageDetails,
    BrandingDetails,
    StudyMilestones,
    RegistrationDetails,
    OnboardingDetails,
    EligibilityDetails,
    eConsentDetails,
    SurveyDetails,
    ePRODetails,
    eDRODetails,
    ActivitiesDetails,
    MobileHealthDataAccess,
    DashboardDetails,
    NotificationsDetails,
    MedicalDevices,
    EngagementContent,
    TeleHealthDetails,
    ParticipantWebDetails,
    ParticipantTriggerDayZeroDetail,
    ParticipantConfiguration
  },
  mounted() {}
};
</script>
<style scoped lang="scss">
/deep/ .expand-collapse-container {
  display: none;
}
/deep/ .fa.fa-minus-circle {
  display: none;
}
/deep/ .fa.fa-plus-circle {
  display: none;
}
/deep/ .inner-card {
  margin: 0;
  background-color: #fff;
}
/deep/ .card {
  border: none;
}
/deep/ .extra-content {
  border: 1px solid rgba(0, 0, 0, 0.125);
  padding: 5px;
}
.pdf-item {
  padding: 10px;
}
</style>
